const resource = 'api/services';
export default ($http) => ({
  getCurrentServices() {
    return $http.get(`${resource}/current`);
  },
});
